import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./Client.css";


const StatsSection = () => {
  const [clients, setClients] = useState(0);
  const [countries, setCountries] = useState(0);
  const [projects, setProjects] = useState(0);

  const sectionRef = useRef(null);

  // Number ticker effect
  const animateValue = (setValue, end, duration) => {
    let start = 0;
    const stepTime = Math.abs(Math.floor(duration / end));
    const timer = setInterval(() => {
      start += 1;
      setValue(start);
      if (start >= end) clearInterval(timer);
    }, stepTime);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          animateValue(setClients, 15, 1000);
          animateValue(setCountries, 6, 1000);
          animateValue(setProjects, 30, 1000);
        }
      },
      { threshold: 0.3 } // Trigger when 30% visible
    );
      const currentSection = sectionRef.current; // ✅ store current value

    if (currentSection) observer.observe(currentSection);

    return () => {
      if (currentSection) observer.unobserve(currentSection); // ✅ use stored value
    };
  }, []);

  return (
    <div className="stats-section" ref={sectionRef}>
      <Container>
      <div className="heading mb-4">Our Impact</div>
        <Row className="g-4 text-center">
          {/* Card 1 */}
          <Col lg={4} md={4} sm={12}>
            <Card className="stats-card ">
              <Card.Body>
                <h2 className="stats-number">{clients}+</h2>
                <p className="stats-text">Happy Clients</p>
              </Card.Body>
            </Card>
          </Col>
          {/* Card 2 */}
          <Col lg={4} md={4} sm={12}>
            <Card className="stats-card">
              <Card.Body>
                <h2 className="stats-number">{countries}+</h2>
                <p className="stats-text">Countries Served</p>
              </Card.Body>
            </Card>
          </Col>

          {/* Card 3 */}
          <Col lg={4} md={4} sm={12}>
            <Card className="stats-card">
              <Card.Body>
                <h2 className="stats-number">{projects}+</h2>
                <p className="stats-text">Completed Projects</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default StatsSection;
